import React, { useCallback, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Divider, InputAdornment, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Skeleton, TextField, styled } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CircleIcon from '@mui/icons-material/Circle';
import { Col, Row } from 'react-bootstrap';
import { BUISNESS_GROUP_TEXT, NO_STORES_TEXT, VIEW_DASHBOARD_TEXT, YOUR_STORES_TEXT, SEARCH_A_STORE_ID } from '../../constants/buttonConstants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { storeListSelectorSaga } from '../../redux/saga/storePageSelectors';
import { WarningOutlined } from '@mui/icons-material';
import { getStoreSummaryRequest, getSingleStoreDetailsRequest } from '../../redux/actions/storeActions';
import './pop-over.scss';
import { useMerchant } from '../../MerchantContext';
import { MERCHANT_NAME } from '../../constants/merchantsConstants';
import { getStatusColor, getItemName } from '../utils/format.helpers';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#aeaeae',
    fontWeight: '700'
  },
  '& .MuiTextField-root': {
    margin: '0px !important'
  }
});

function ListSearchPopOver({ open, onClose, storeSelected }) {

	const [loading, setLoading] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const wholeList = useSelector(storeListSelectorSaga);
	const { merchantId, merchantName } = useMerchant();
	const [storeName, setStoreName] = useState(null);
  	const [listData, setlistData] = useState([]);
	const [wishList, setWishList] = useState([]);

	useEffect(()=>{
		if(merchantName == null) {
			setStoreName(MERCHANT_NAME);
		} else {
			setStoreName(merchantName);
		}

	}, [merchantName])
  
	useEffect(()=>{
		// console.log('STORE LIST ',wholeList, wholeList.constructor === Array, open)
		if(wholeList !== null && wholeList.constructor === Array && open){
		setLoading(false);
		setlistData(wholeList);
		} else if(wholeList && wholeList?.msg){
		setLoading(false);
		setlistData([]);
		}
	},[wholeList])

	useEffect(()=>{
		if(open){
			setLoading(true);
		// console.log('MERCHANT ID ',merchantId)
			if(merchantId && merchantId !== '') {
				dispatch(getStoreSummaryRequest(merchantId));
			} else {
			setLoading(false);
			setlistData([]);
		}
		}
	},[open])

	const handleChange = (e) => {
		// console.log('SEARCH TEXT ',e.target.value)
	}
	const handleClose = () => {
		onClose(null);
	};

	const handleStoreClick = (item) => {
		//console.log('ITEM ',item);
		storeSelected(item);
		//console.log('list123:', item.sourceId);
		dispatch(getSingleStoreDetailsRequest(merchantId, item.storeUuid, item.sourceId));
		navigate(`/dashboard/orders`, {
			state: {
				hamBurger: true,
				selectedIndex: 0,
				pathname: '/dashboard/orders'
			}
		});
	}

	const handleListItemClick = (index) => {
		setSelectedIndex(index);
	}

	const handleKeyEventSearch = (e) => {
		if (e.keyCode == 13) {
		// console.log('value', e.target.value, wholeList.filter(item => { return item.name.indexOf(e.target.value) > -1}));
		setLoading(true);
		setlistData(wholeList.filter(item => {return (item.name.indexOf(e.target.value) > -1 || String(item.sourceId).indexOf(e.target.value) > -1)}));
		setTimeout(() => {
			setLoading(false);
		}, 2000)
		}
	}

	const dashboardSelected = ()=> {
		
		storeSelected({
		sourceId: [],
		name: storeName
		});
		navigate(`/dashboard/orders`, {
			state: {
				hamBurger: true,
				selectedIndex: 0,
				pathname: '/dashboard/orders'
			}
		});
	}

	return (
		<Dialog
			data-testid='listsearchpopover'
			sx={{
				'& .MuiDialog-paper': {
				position: 'absolute',
				top: '85px',
				left: '0',
				transform: 'translate(0%, 0%)',
				height: '440px',
				width: 'auto',
				padding: '16px',
				margin: '32px 32px 32px 12px',
				maxWidth: '630px !important',
				borderRadius: '8px'
				},
				'& .MuiDialog-container': {
				display: 'flex !important',
				justifyContent: 'flex-start !important'
				},
				'& .MuiBackdrop-root': {
					backgroundColor: 'transparent',
				},
			}}
			onClose={handleClose} open={open}
		>
			<DialogTitle
				sx={{ padding: '0 !important' }}><CssTextField
				id='searchText'
				placeholder={SEARCH_A_STORE_ID}
				onChange={handleChange}
				required
				variant='outlined'
				color='primary'
				type='text'
				disabled={loading}
				aria-label='Search Box'
				fullWidth
				onKeyDown={(e) => handleKeyEventSearch(e)}
				sx={{ mb: 3, width: '100%', marginBottom: '0px !important', padding: '0 !important' }}
				inputProps={{ fontSize: '26px' }}
				InputProps={{
					startAdornment: (
					<InputAdornment position='start'>
						<SearchIcon />
					</InputAdornment>
					),
				}}
				/>
			</DialogTitle>

			<Divider sx={{ margin: '14px 0px 8px 0px !important' }} />
			<DialogContent className='dialog-cont--content' sx={{ justifyContent: 'left !important', padding: '0px !important', margin: '0px !important' }}>
				{wishList.length > 0 ?
				<div className='dialog-cont--wishlist-holder'>
					<div className='dialog-cont--wishlist-list'>
					<h5 className='search-box--left-title'>{storeName}</h5>
					<p className='search-box--view-buisness'>{BUISNESS_GROUP_TEXT}</p>
					<Divider sx={{ margin: '8px 0px 12px 0px !important' }} />
					<List className='search-box--list' sx={{ pt: 0, height: '240px', width: '270px' }}
						aria-labelledby='nested-list-subheader'>
						{wishList.map((item, index) => {
						const labelId = `WishList Item ${item.name.indexOf(item.streetAddress)>-1? item.name.replace(item.streetAddress, '').trim() : item.name}`;
						return (<ListItem className='search-box--list__item' sx={{ width: 'auto', height: '60px', paddingTop: '0px', paddingBottom: '0px' }} disableGutters key={index}>
							<ListItemButton className='search-box--list__item__button search-box--list__item__button__nopadding' selected={selectedIndex === index}
							sx={{
								'&.Mui-selected': {
								backgroundColor: 'rgba(230, 241, 238, 1)'
								}
							}}
							role={undefined} onClick={() => handleListItemClick(index)} dense>
							<Row className='search-box--list__item__button'>
								<ListItemText className='search-box--list__item__button__label' id={labelId} primary={getItemName(item)} />
								<ListItemText className='search-box--list__item__button__subLabel' primary={`${item.stores.length} stores`} />
							</Row>

							</ListItemButton>
						</ListItem>
						);
						})
						}
					</List>
					</div>

					<div style={{ 'display': 'flex', 'flexDirection': 'column', 'height': '330px', 'width': '335px', 'overflow': 'hidden' }}>
						<div className='search-box--dashboard-box' onClick={() => navigate('/dashboard')} data-testid='dashboardtext'>
							<h5 className='search-box--title'>{storeName}</h5>
							<p className='search-box--view-dashboard'>{VIEW_DASHBOARD_TEXT}</p>
						</div>
						<Divider sx={{ margin: '8px 0px 12px 0px !important' }} />
						<p className='search-box--view-store-text'>{YOUR_STORES_TEXT}</p>
						<List className='search-box--list' sx={{ pt: 0, height: '220px', width: '335px' }}
							aria-labelledby='nested-list-subheader'>
							{wishList[selectedIndex].stores.map((item, index) => {
							const labelId = `Location item ${item.name.indexOf(' - ')? item.name.split(' - ')[0].trim() : item.name}`;
							return (
								<ListItem className='search-box--list__item' sx={{ width: 'auto', height: '60px', paddingTop: '0px', paddingBottom: '0px' }} disableGutters key={index}>
									<ListItemButton className='search-box--list__item__button search-box--list__item__button__nopadding' role={undefined}
									sx={{
										'&.Mui-selected': {
										backgroundColor: 'rgba(230, 241, 238, 1)'
										}
									}}
									onClick={handleToggle(item)} dense>
										<ListItemIcon>
											<CircleIcon sx={{ color: getStatusColor(item) }} />
										</ListItemIcon>
										<Row className='search-box--list__item__button'>
											<ListItemText primaryTypographyProps={{ className: 'search-box--list__item__button__label' }} id={labelId} primary={getItemName(item)} />
											<ListItemText primaryTypographyProps={{ className: 'search-box--list__item__button__subLabel' }} primary={item.streetAddress} />
										</Row>
									</ListItemButton>
								</ListItem>
							);
							})
							}
						</List>
					</div>
				</div> :
				<div style={{ 'display': 'flex', 'flexDirection': 'column', 'height': '330px', 'overflow': 'hidden' }}>
					<div className='search-box--dashboard-box' onClick={() => dashboardSelected()} data-testid='dashboardtext'>
						<h5 data-testid='no-store-title' className='search-box--title'>{storeName}</h5>
						<p className='search-box--view-dashboard'>{VIEW_DASHBOARD_TEXT}</p>
					</div>
					<Divider sx={{ margin: '8px 0px 12px 0px !important' }} />
					<p className='search-box--view-store-text'>{YOUR_STORES_TEXT}</p>
					{loading ? <Skeleton variant='rectangular' width='330px' data-testid='skeleton'>
					<div style={{ paddingTop: '57%' }} />
					</Skeleton> : <List className='search-box--list' sx={{ pt: 0, height: '220px', width: '330px' }}
					aria-labelledby='nested-list-subheader'>
					{listData.length > 0 ? listData.map((item, index) => {
						const labelId = `Location item ${item.label}`;

						return (<ListItem className='search-box--list__item' sx={{ width: 'auto', height: '60px', paddingTop: '0px', paddingBottom: '0px' }} disableGutters key={index}>
						<ListItemButton className='search-box--list__item__button  search-box--list__item__button__nopadding' role={undefined}
							sx={{
							'&.Mui-selected': {
								backgroundColor: 'rgba(230, 241, 238, 1)'
							}
							}}
							onClick={()=>handleStoreClick(item)} dense>
							<ListItemIcon className='search-box--list__item__icon_cont'>
							<CircleIcon className='search-box--list__item__icon' sx={{ color: getStatusColor(item) }} />
							</ListItemIcon>
							<Row className='search-box--list__item__button'>
							<ListItemText primaryTypographyProps={{ className: 'search-box--list__item__button__label' }} id={labelId} primary={getItemName(item)} />
							<ListItemText primaryTypographyProps={{ className: 'search-box--list__item__button__subLabel' }} primary={item.streetAddress} />
							</Row>
						</ListItemButton>
						</ListItem>
						);
					})
					: 
					<Col className='search-box--list__no-store-class'>
						<WarningOutlined/>
						<span>{NO_STORES_TEXT}</span>
					</Col>}
					</List>
					}
				</div>
				}
			</DialogContent>

		</Dialog>
	);
}

export default ListSearchPopOver;
